import { datadogRum } from '@datadog/browser-rum';
import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

export default function useDatadogAddError(error, params) {
  const userDetailsStore = useUserDetailsStore();
  const { user } = storeToRefs(userDetailsStore);
  datadogRum.addError(error, {
    ...params,
    user: user.value,
  });
}
